import React, {ReactElement} from 'react';
import {useSelector} from 'react-redux';
import {showGridSelector} from '../../../../store/selectors/grid';

interface GridComponentProps {
    cellWidth: number;
    cellHeight: number;
}
function GridComponent(props: GridComponentProps): ReactElement {
    const {cellWidth, cellHeight} = props;
    const showGrid = useSelector(showGridSelector);

    const strokeWidth = 0.5;
    const cGrid = {
        position: 'absolute' as const,
        top: -strokeWidth,
        left: -strokeWidth,
        width: 'calc(100% + 1px)',
        height: 'calc(100% + 1px)',
    };

    if (showGrid === false) return <div />;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" style={cGrid} className="c-presGrid">
            <defs>
                <pattern id="smallGrid" width={cellWidth} height={cellHeight} patternUnits="userSpaceOnUse">
                    <path d={`M ${cellWidth} 0 L 0 0 0 ${cellHeight}`} fill="none" stroke="#9d9d9d" strokeWidth={strokeWidth} />
                </pattern>
                <pattern id="grid" width={cellWidth} height={cellHeight} patternUnits="userSpaceOnUse">
                    <rect width={cellWidth} height={cellHeight} fill="url(#smallGrid)" />
                </pattern>
            </defs>

            <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
    );
}

export default GridComponent;
